module.exports = true;


/*****************
 ** WEBPACK FOOTER
 ** /Users/nw/flint/flintjs-deps/~/core-js/library/modules/$.library.js
 ** module id = 12
 ** module chunks = 2
 **/